module.exports = __webpack_public_path__ + "img/pay-per-mile-rates.e26819b5.jpg";